import { Component, output } from '@angular/core';

import { TranslatePipe } from '@core/i18n-legacy';
import { HrAssistantIconComponent } from '@core/intelligence-ui';
import { IconButtonComponent } from '@core/user-interface-legacy';

@Component({
  selector: 'tlc-header-welcome',
  imports: [HrAssistantIconComponent, TranslatePipe, IconButtonComponent],
  template: `
    <hr-assistant-icon [size]="24" />
    <span text-semi-medium text-darkest="">
      {{ 'tlc.hr_assistant.hr_assistant' | translate }}
    </span>
    <div class="badge">
      {{ 'tlc.common.beta' | translate }}
    </div>
    <rt-icon-button
      iconName="close"
      size="small"
      variant="plain"
      (click)="close.emit($event)"
      margin-left-auto
    />
  `,
  styleUrls: ['./header-welcome.component.less'],
})
export class HeaderWelcomeComponent {
  public close = output<MouseEvent>();
}
